import type { IAccommodationItem } from '@/entities/accommodation/types';
import type { IActivityItem } from '@/entities/activity/types';
import type { IProduct } from '@/entities/product/types';
import type { ISlotItem } from '@/entities/slot/types';

export function filterProduct(response: any) {
  const product: IProduct = {
    idx: response.idx,
    title: response.title,
    description: response.description,
    cancellationPolicy: response?.cancellationPolicy || '',
    additionalInfo: response?.additionalInfo,
    currency: response.currency,
    thumbnail: response.thumbnail,
    detailImage: response.detailImage,
    productMerchant: response?.productMerchant
      ? {
          name: response.productMerchant.name,
          logoImage: response.productMerchant.logoImageFile,
        }
      : null,
    isActive: response.isActive,
    itemList: [],
  };

  const rawAccommodationItemList = response.productItems.filter(
    (item: any) => item.type === 'ACCOMMODATION',
  );
  const rawActivityItemList = response.productItems.filter((item: any) => item.type === 'ACTIVITY');
  const rawSlotItemList = response.productItems.filter((item: any) => item.type === 'SLOT');

  const accommodationItemList: IAccommodationItem[] =
    rawAccommodationItemList?.map((item: any) => {
      return {
        idx: item.data.idx,
        type: item.type,
        title: item.data.title,
        description: item.data.description,
        descriptionGoto: item.data?.descriptionGoto || '',
        included: item.data?.included || '',
        excluded: item.data?.excluded || '',
        adultCount: item.data.adultCount,
        childCount: item.data.childCount,
        addAdultCount: item.data.addAdultCount,
        addChildCount: item.data.addChildCount,
        isActive: item.data.isActive,
        roomOptionTypeList: item.data.roomOptionTypes.map((option: any) => {
          return {
            idx: option.idx,
            title: option.title,
            description: option.description,
            price: option.price,
            type: option.type,
            isActive: option.isActive,
          };
        }),
        roomPriceList: item.data.roomPriceList.map((roomPriceData: any) => {
          return {
            idx: roomPriceData.idx,
            date: roomPriceData.date,
            availableCount: roomPriceData.availableCount,
            price: roomPriceData.price,
            isActive: roomPriceData.isActive,
          };
        }),
      };
    }) ?? [];

  const activityItemList: IActivityItem[] =
    rawActivityItemList?.map((item: any) => {
      const startDate = new Date(item.data.startDate);
      const endDate = new Date(item.data.endDate);

      return {
        idx: item.data.idx,
        type: item.type,
        title: item.data.title,
        description: item.data.description,
        descriptionGoto: item.data?.descriptionGoto || '',
        included: item.data?.included || '',
        excluded: item.data?.excluded || '',
        startDate,
        endDate,
        availableCount: item.data.availableCount,
        maxPurchaseCount: item.data.maxPurchaseCount,
        price: item.data.price,
        isActive: item.data.isActive,
        optionGroupList: item.data.optionGroups.map((optionGroup: any) => {
          return {
            idx: optionGroup.idx,
            title: optionGroup.title,
            description: optionGroup?.description || '',
            isMultiSelect: optionGroup.isMultiSelect,
            isActive: optionGroup.isActive,
            isRequired: optionGroup.isRequired,
            optionList: optionGroup.options.map((option: any) => {
              return {
                idx: option.idx,
                title: option.title,
                price: option.price,
                isActive: option.isActive,
              };
            }),
          };
        }),
      };
    }) ?? [];

  const slotItemList: ISlotItem[] =
    rawSlotItemList?.map((item: any) => {
      return {
        idx: item.data.idx,
        type: item.type,
        title: item.data.title,
        description: item.data.description,
        descriptionGoto: item.data?.descriptionGoto || '',
        included: item.data?.included || '',
        excluded: item.data?.excluded || '',
        date: new Date(item.data.date),
        isActive: item.data.isActive,
        slotOptionTitle: item.data?.slotBoxesTitle || '',
        slotOptionList: item.data.slotBoxes.map((slotOption: any) => {
          return {
            idx: slotOption.idx,
            title: slotOption.title,
            price: slotOption.price,
            type: slotOption.type,
            maxCount: slotOption.maxCount,
            availableCount: slotOption.availableCount,
            isActive: slotOption.isActive,
          };
        }),
        optionGroupList: item.data.optionGroups.map((optionGroup: any) => ({
          idx: optionGroup.idx,
          title: optionGroup.title,
          description: optionGroup.description,
          isMultiSelect: optionGroup.isMultiSelect,
          isActive: optionGroup.isActive,
          optionList: optionGroup.options.map((option: any) => ({
            idx: option.idx,
            title: option.title,
            price: option.price,
            isActive: option.isActive,
          })),
        })),
      };
    }) ?? [];

  product.itemList = [...accommodationItemList, ...activityItemList, ...slotItemList];

  return product;
}
